import type { Theme } from '@mui/material/styles';

type SxClasses = Record<string, object>;

/**
 * Get custom sx classes for the layer left panel
 *
 * @param theme - The theme object
 * @returns The sx classes object
 */
export const getSxClasses = (theme: Theme): SxClasses => ({
  list: {
    color: 'text.primary',
    width: '100%',
    overflowY: 'auto',

    // list item
    '& .MuiListItem-root': {
      height: '100%',
      flexDirection: 'column',
      alignItems: 'stretch',
      '& > .MuiBox-root': {
        height: '100%',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.geoViewColor.grey.darken(1, 0.12)}`,
      },
    },

    // TODO: WCAG Issue #3236 -  Overly complex. Consider using a CSS class name to identify the deepest nested list items
    // list item boxes - remove border from sub-level list box if the list does not contain sub-items
    '& > .MuiListItem-root:has(ul) ul:not(:has(ul)):last-of-type > li:last-child > .MuiBox-root': {
      borderBottom: 'none',
    },

    // list item button
    '& .MuiListItemButton-root': {
      padding: '0 2px 0 16px',
      height: '100%',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&.Mui-selected:not(.Mui-focusVisible)': {
        backgroundColor: 'transparent',
      },
    },

    // layer title
    '& .MuiListItemText-primary': {
      fontWeight: '600',
      fontSize: `${theme.palette.geoViewFontSize.default} !important`,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },

    '& .layer-panel': {
      '& .MuiListItemText-root': {
        marginLeft: '12px',
      },

      // styling right icons
      '& .rightIcons-container': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        alignItems: 'center',

        '& .MuiIconButton-root': {
          margin: '0px 1px',
        },
      },
    },

    '& .MuiListItemIcon-root': {
      minWidth: '2.5rem',
      marginRight: '5px',
    },
    '& .MuiListItemText-root': {
      '> span': {
        fontSize: theme.palette.geoViewFontSize.default,
      },
      '> p': {
        fontSize: theme.palette.geoViewFontSize.sm,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: `${theme.palette.geoViewColor.textColor.main} !important`,
        fontWeight: '400 !important',
      },
    },
  },
  listSubitem: {
    padding: '0px',
    marginLeft: '20px',
    width: 'unset',
    boxSizing: 'border-box',
    '& .layerItemContainer': {
      backgroundColor: 'transparent',
      marginBottom: '0px',
    },
  },
});
